/* eslint-disable flowtype/no-types-missing-file-annotation */
import {connect} from 'react-redux';
import React from 'react';
import {TripBoardButton} from '@homeaway/react-trip-board-button';

import {State as ReduxState} from '../../reducers';

import {ListingShape as HitListingShape} from '../Hit/Hit';

export type StateProps = {
    isMobile?: boolean;
};

type Props = {
    listing: HitListingShape;
    isMapHit?: boolean;
} & StateProps;

const TripBoardComponent = ({
    listing: {propertyMetadata, images, listingId, averageRating, reviewCount},
    isMapHit = false,
    isMobile
}: Props) => (
    <TripBoardButton
        expandedButton={!isMobile}
        headline={(propertyMetadata && propertyMetadata.headline) || ''}
        listingId={listingId}
        averageRating={averageRating}
        reviewCount={reviewCount}
        tabIndex={-1}
        thumbnailUrl={images && images[0] && images[0].c9_uri}
        useNativeEventListener={isMapHit}
        redOnHover
    />
);

export const mapStateToProps = (state: ReduxState): StateProps => {
    const {system} = state;
    const {isMobile, isTablet} = system;

    return {
        isMobile: isMobile && !isTablet
    };
};

export default connect(mapStateToProps)(TripBoardComponent);
